import { atom, useAtom } from 'jotai';

export const modalContentAtom = atom<JSX.Element | null>(null);

export function useModal() {
  const [modalContent, setModalContent] = useAtom(modalContentAtom);

  return {
    modalContent,
    openModal: setModalContent,
    closeModal: () => setModalContent(null),
  };
}
